import React from 'react'
import SbEditable from 'storyblok-react'

const InspirationHeaderBlock = ({ block }) => {
  return (
    <SbEditable content={block}>
      <section className="inspiration-header-block">
        <div className="inspiration-header-block-overlay"></div>
        <div className="inspiration-header-block-container">
          <div className="inspiration-header-block-content">
            <h1>{block.headline}</h1>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default InspirationHeaderBlock
